import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import appSettings from "@/store/modules/app-settings";

const { state, actions, mutations } = appSettings;

// Default getter for root Store
const getAllState = (stateStore) => stateStore;

// Add plugin to Vue
Vue.use(Vuex);

// Add localstorage persistence for Vuex
const vuexLocalStorage = new VuexPersist({
  key: "tlt-vuex-recruitment-prod" // The key to store the state on in the storage provider.
  , storage: window.localStorage // or window.sessionStorage or localForage or localStorage
});

// Create Store
const store = new Vuex.Store({
  state
  , actions
  , mutations
  , getters: { getAllState }

  // Adding plugins to vuex instance
  , plugins: [vuexLocalStorage.plugin]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js